/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileAnalyticsCumulativeHistogram } from '../../models/profile-analytics-cumulative-histogram';

export interface ProfilePageviewsDateHistogram$Params {
  id: number;
}

export function profilePageviewsDateHistogram(http: HttpClient, rootUrl: string, params: ProfilePageviewsDateHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>> {
  const rb = new RequestBuilder(rootUrl, profilePageviewsDateHistogram.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileAnalyticsCumulativeHistogram>;
    })
  );
}

profilePageviewsDateHistogram.PATH = '/analytics/profile/{id}/pageviews';
